var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"new-btn btn--sec-pine-white request-visit",attrs:{"id":"request-visit-button","type":"button"},on:{"click":_vm.handleClick}},[_vm._v("\n        "+_vm._s(_vm.$t("ficha_nueva.request_visit"))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }